import { Clinic, Optins } from '@ana/shared'

export enum AnamnesisState {
  NOT_REQUIRED = 'NOT_REQUIRED',
  MISSING = 'MISSING',
  EXPIRED = 'EXPIRED',
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum AnamnesisStepName {
  ANAMNESIS = 'ANAMNESIS',
  FACTORING_AGREEMENT = 'FACTORING_AGREEMENT',
}

export enum AnamnesisStepType {
  FORM = 'FORM',
  DOCUMENT = 'DOCUMENT',
}

export type AnamnesisStep = {
  entityReferenceId: string | null
  step: string
  status: AnamnesisState
  submitDate: string | null
  type: AnamnesisStepType
  requiresSignature: boolean
  signatureDocumentUrl: string | null
}

export type Tenant = {
  referenceId: string
  internal: boolean
  subscribedForProducts: string[]
}

type Patient = {
  referenceId: string
  firstName?: string
  lastName?: string
  gender?: string
  clinic: Clinic
  tenant: Tenant
  hasHealthAssistant: boolean
  bookedForDifferentPerson: boolean
  anamnesisState: AnamnesisStep[]
  optins?: Optins
}

export default Patient
